export const cookieConsentConfig = {
  revision: 1,

  guiOptions: {
    consentModal: {
      layout: "box inline",
      position: "bottom left",
      equalWeightButtons: false,
      flipButtons: false,
    },
    preferencesModal: {
      layout: "box",
      position: "right",
      equalWeightButtons: true,
      flipButtons: false,
    },
  },

  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {
      enabled: false,
      autoClear: {
        cookies: [{ name: /^(_ga|_gid|mp_)/ }],
      },
    },
    marketing: {
      enabled: false,
      autoClear: {
        cookies: [{ name: /^(_fbp|_fbc)/ }],
      },
    },
  },

  language: {
    default: "en",
    autoDetect: "browser",
    translations: {
      en: {
        consentModal: {
          title: "We use cookies",
          description:
            "We use cookies to improve your experience and analyse how our platform is used. You can choose which categories to allow.",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          showPreferencesBtn: "Manage preferences",
          footer: '<a href="/privacy">Privacy Policy</a> &middot; <a href="/impressum">Legal Notice</a>',
        },
        preferencesModal: {
          title: "Cookie preferences",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          savePreferencesBtn: "Save preferences",
          closeIconLabel: "Close",
          serviceCounterLabel: "Service|Services",
          sections: [
            {
              title: "Strictly necessary",
              description:
                "These cookies are required for the platform to function and cannot be disabled.",
              linkedCategory: "necessary",
            },
            {
              title: "Analytics",
              description:
                "Help us understand how partners use Appdesh so we can improve the product. Includes Mixpanel and Google Analytics.",
              linkedCategory: "analytics",
            },
            {
              title: "Marketing",
              description:
                "Used to deliver relevant communications and measure campaign effectiveness.",
              linkedCategory: "marketing",
            },
          ],
        },
      },
      de: {
        consentModal: {
          title: "Wir verwenden Cookies",
          description:
            "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern und die Nutzung unserer Plattform zu analysieren. Sie können wählen, welche Kategorien Sie zulassen möchten.",
          acceptAllBtn: "Alle akzeptieren",
          acceptNecessaryBtn: "Alle ablehnen",
          showPreferencesBtn: "Einstellungen verwalten",
          footer: '<a href="/privacy">Datenschutzerklärung</a> &middot; <a href="/impressum">Impressum</a>',
        },
        preferencesModal: {
          title: "Cookie-Einstellungen",
          acceptAllBtn: "Alle akzeptieren",
          acceptNecessaryBtn: "Alle ablehnen",
          savePreferencesBtn: "Einstellungen speichern",
          closeIconLabel: "Schließen",
          serviceCounterLabel: "Dienst|Dienste",
          sections: [
            {
              title: "Unbedingt erforderlich",
              description:
                "Diese Cookies sind für die Funktion der Plattform erforderlich und können nicht deaktiviert werden.",
              linkedCategory: "necessary",
            },
            {
              title: "Analyse",
              description:
                "Helfen uns zu verstehen, wie Partner Appdesh nutzen, damit wir das Produkt verbessern können. Beinhaltet Mixpanel und Google Analytics.",
              linkedCategory: "analytics",
            },
            {
              title: "Marketing",
              description:
                "Werden verwendet, um relevante Kommunikation bereitzustellen und die Kampagneneffektivität zu messen.",
              linkedCategory: "marketing",
            },
          ],
        },
      },
    },
  },
}
